import { render } from "./IntroductionSection.vue?vue&type=template&id=2faa9070"
import script from "./IntroductionSection.vue?vue&type=script&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&lang=js"

import "./IntroductionSection.vue?vue&type=style&index=0&id=2faa9070&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__